// extracted by mini-css-extract-plugin
export default {"container":"_-_-record-it-components-src-button-ButtonsContainer-__container","alignRight":"_-_-record-it-components-src-button-ButtonsContainer-__alignRight"};